import * as React from "react";
import { computed, action } from "mobx";
import { observer, inject } from "mobx-react";
import { AreaAside } from "./AreaAside";
import * as UiStore from "../States/AreaUiInfo";


export interface IAreaProps extends UiStore.IAreaUiInfo {
	asideComponent?: React.ReactElement<AreaAside>;
}


@inject((allStores : any) => ({
	areaUiInfo: allStores.areaUiInfo as UiStore.AreaUiInfoImpl
}))
@observer
export class Area extends React.Component<IAreaProps, {}> {

	@action handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.areaUiInfo.dragMove(event.pageX);
	}

	@action handleMouseUp = (event: React.MouseEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.areaUiInfo.dragEnd();
	}

	@action handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.areaUiInfo.dragMove(event.touches.item(0).pageX);
	}

	@action handleTouchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.areaUiInfo.dragEnd();
	}

	@action handleTouchCancel = (event: React.TouchEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.areaUiInfo.dragCancel();
	}

	render() {
		if (this.props.asideComponent) {
			let dragging = this.props.areaUiInfo && this.props.areaUiInfo.isDragging;
            return <div className="area-grid is--split">
				{this.props.asideComponent ? this.props.asideComponent : null}
				{this.props.children}
				{dragging ? <div className="grid-splitter-drag-background"
					onMouseMove={this.handleMouseMove} onMouseUp={this.handleMouseUp}
					onTouchMove={this.handleTouchMove} onTouchEnd={this.handleTouchEnd} onTouchCancel={this.handleTouchCancel} /> : null}
			</div>;
		}
		else {
			return <div className="area-grid is--regular">
				{this.props.children}
			</div>;
		}

	}
}
